<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div>
        <vs-select class="w-full" autocomplete v-model="select" :disabled="disabled" @change="change">
          <vs-select-item v-for="(item, i) in items" :key="`${i}_${item}`" :text="getText(item)" :value="getValue(item)" />
        </vs-select>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div>
        <vs-select class="w-full" autocomplete v-model="select" :disabled="disabled" @input="input" @change="change">
          <vs-select-item v-for="(item, i) in items" :key="`${i}_${item}`" :text="getText(item)" :value="getValue(item)" />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";
import { listTableMethods as DataUtil } from "@/util/DataUtil";

export default {
  name: "SearchSelect",
  components: {
    SearchFilterItem,
    FieldSelector,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "사업장명",
      type: String,
    },
    value: [String, Number],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          's_s': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.select = value
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    defaultValue () {
      return this.options && this.options['default'] ? this.options['default'] : '';
    },
    initData() {
      const defaultValue = this.defaultValue;
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const select = query[_query_keys[0]];
      if (select) {
        try {
          return {
            select: select || defaultValue,
          };
        } catch (e) {}
      }
      return {
        select: defaultValue,
      };
    },
    gridTemplateColumns() {
      return this.options && this.options.gridTemplateColumns ? this.options.gridTemplateColumns : 'auto auto';
    },
    immediate () {
      return this.options && this.options.immediate ? this.options.immediate : false;
    },
    items() {
      try {
        if (this.options.items) return this.options.items;
        if (this.options.itemsSearchKeys) {
          const itemsSearchKeys = this.options.itemsSearchKeys;
          let itemsJSON = this.options.itemsJSON;
          const keywords = []
          for (const key of itemsSearchKeys) {
            const keyword = DataUtil.findJsonDataWithDottedPath(this.nav, key)
            if (keyword) {
              keywords.push(keyword);
              itemsJSON = itemsJSON[keyword];
            }
          }

          // itemsSearchKeys 등록한 key 에 해당하는 값이 this.nav 에 모두 있을 경우에만 목록을 표기하기 위해 keywords.length 와 itemsSearchKeys.length 비교
          if (keywords.length === itemsSearchKeys.length && itemsJSON) {
            let items = [];
            if (Array.isArray(itemsJSON)) {
              items = itemsJSON
            } else {
              items = Object.keys(itemsJSON);
            }

            if (items.indexOf(this.value) === -1) {
              this.select = '';
            }

            return items
          }
        }
      } catch (e) {
        console.error("Error in items computation:", e);
      }

      return [];
    },
    disabled() {
      return this.options.disabled || false;
    },
    nav() {
      return this.options.nav || {};
    }
  },
  data() {
    return {
      select: "",
    };
  },
  created() {
    this.select = this.initData.select;
    this.$emit("input", this.select);
    if (this.immediate) {
      this.$emit("select", this.select);
    }
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    input(data) {
      this.$emit("select", data || this.defaultValue);
    },

    change(data) {
      this.$emit("input", data || this.defaultValue);
    },
    onClickFilterRemove () {
      this.select = this.defaultValue;
      this.$emit("input", this.select);
    },
    getText(item){
      if (typeof item === 'object') {
        return item.text;
      }
      return item;
    },
    getValue(item){
      if (typeof item === 'object') {
        return item.value;
      }
      return item;
    },
  },
};
</script>
